import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paginator',
})
export class PaginatorPipe implements PipeTransform {
  transform(value: any[], start: number, end: number): unknown {
    return value.slice(start, end);
  }
}
